// IN: 人->机器人 OUT: 人<-机器人 HIN: 人 -> 客服 HOUT: 人 <- 客服
import {HttpService} from './httpService'

const getFileImg = function (filename) {
  let src
  let type = filename.split('.')[filename.split('.').length - 1]
  switch (type) {
    case 'xlsm':
    case 'xlsx':
    case 'xltx':
    case 'xltm':
    case 'xlsb':
    case 'xlam':
      src = require('../src/assets/filetype/excel.png')
      break
    case 'pptx':
      src = require('../src/assets/filetype/ppt.png')
      break
    case 'docx':
    case 'docm':
    case 'dotx':
    case 'dotm':
      src = require('../src/assets/filetype/word.png')
      break
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
      src = require('../src/assets/filetype/picture.png')
      break
    case 'zip':
      src = require('../src/assets/filetype/zip.png')
      break
    case 'mp4':
      src = require('../src/assets/filetype/mp4.png')
      break
    case 'mp3':
    case 'wav':
      src = require('../src/assets/filetype/mp3.png')
      break
    default:
      src = require('../src/assets/filetype/file.png')
  }
  return src
}

export class Visitor {
  constructor() {
    this.visitorId = ''
    this.lastMessage = {}
    this.lastMessagetime = ''
    this.time = ''
    this.count = 0
    this.isHistory = true
    this.conversationId = ''
    this.robotId = ''
    this.channel = ''
    this.messageType = 'TEXT'
    this.transfer = false
    this.hasHistory = true
    this.robotName = ''
  }
}

export class KnowRule {
  constructor() {
    this.categoryName = ''
    this.CategoryId = ''
    this.changeIsAll = ''
    this.ruleStatus = ''
    this.page = ''
  }
}

export class Message {
  constructor() {
    this.time = ''
    this.msg = ''
    this.name = ''
    this.robotId = ''
    this.visitorId = ''
    this.conversationId = ''
    this.messageId = ''
    this.messageType = 'TEXT'
    this.direction = 'OUT'
    this.firstIn = false
    this.humanUserId = ''
  }
}

export class VisitorInfo {
  constructor() {
    this.agentVersion = ''
    this.channel = ''
    this.city = ''
    this.company = ''
    this.county = ''
    this.deviceId = ''
    this.hardwareVersion = ''
    this.ip = ''
    this.mail = ''
    this.nickname = ''
    this.phone = ''
    this.province = ''
    this.qq = ''
    this.remarks = ''
    this.username = ''
    this.visitorId = ''
  }
}

export class FeedbackData {
  constructor() {
    this.conversation_id = ''
    this.human_answer = ''
    this.human_id = ''
    this.question_id = ''
    this.rec_id = ''
    this.rec_type = ''
    this.timestamp = ''
  }
}

const audio = document.createElement('audio')
audio.controls = true //这样控件才能显示出来
audio.src = require('../src/assets/audio/message.mp3')

let nowQueueTimer = null

export class PlatformService {
  constructor() {
    this.visitorLIst = []
    this.nowVisitor = new Visitor()
    // visitorId和messageList的映射
    this.allMessage = new Map()
    // 对visitor user robot 信息进行缓存
    this.allVisitor = new Map()
    this.allUser = new Map()
    this.allRobot = new Map()
    this.ws = null
    // 状态
    this.status = ''
    this.auth = ''
    this.cvsOrder = 'COMEIN' // 当前会话排序方式: COMEIN  TIME
    this.kbSwicth = true // 是否开启智能助手实时匹配
    this.visitorIds = [] // 缓存 HUMAN_CVS_LIST ,用于在第一次进入工作台时更新用户列表(注意更新完后清空)
    this.robots = new Map()
    this.conversationType = 'now'
    this.feedBack = (ans, msg) => {
      let data = new FeedbackData()
      data.conversation_id = msg.conversationId
      data.human_answer = ans.answer
      data.human_id = HttpService.getCurrentUser().userId
      data.question_id = msg.messageId
      data.rec_id = ans.rec_id
      data.rec_type = ans.qaresponseType
      data.timestamp = new Date().getTime()
      HttpService.post(`v1/tenants/${HttpService.getCurrentUser().tenantId}/robots/${msg.robotId}/recommend/feedback`, data)

    }
  }

  clearData() {
    this.visitorLIst = []
    this.nowVisitor = new Visitor()
    // visitorId和messageList的映射
    this.allMessage = new Map()
    // 对visitor user robot 信息进行缓存
    this.allVisitor = new Map()
    this.allUser = new Map()
    this.allRobot = new Map()
    this.ws = null
    // 状态
    this.status = ''
    this.auth = ''
    this.cvsOrder = 'COMEIN' // 当前会话排序方式: COMEIN  TIME
    this.kbSwicth = true // 是否开启智能助手实时匹配
    this.visitorIds = [] // 缓存 HUMAN_CVS_LIST ,用于在第一次进入工作台时更新用户列表(注意更新完后清空)
    this.robots = new Map()
    this.conversationType = 'now'
  }

  close() {
    console.warn('前端主动断开')
    !!this.ws && this.ws.close()
  }

  initBench(auth, vue, isClear = true) {
    console.warn('initBench')
    if (isClear) {
      this.clearData()
    }
    this.vue = vue
    this.auth = auth

    this.allUser.set(HttpService.getCurrentUser().userId, HttpService.getCurrentUser())
    let base = 'wss://'
    if (location.protocol === 'http:') {
      base = 'ws://'
    }

    let baseurl = base + (!!process.env.HOST_URL ? process.env.HOST_URL : location.host)
    if (this.visitorLIst.length > 0) {
      if (this.ws == null || this.ws.readyState == 3) {
        this.ws = new WebSocket(baseurl + `/v1/communicate/human?tenantId=${auth.tenantId}&userId=${auth.userId}`)
        this.dealWS(auth)
      }
    } else {
      HttpService.get(`/v1/tenants/${HttpService.getCurrentUser().tenantId}/human/conversation/userRecent?userId=${HttpService.getCurrentUser().userId}`).then(r => {
        this.dealVisitorLLIst(r)
        if (this.ws == null || this.ws.readyState == 3) {
          this.ws = new WebSocket(baseurl + `/v1/communicate/human?tenantId=${auth.tenantId}&userId=${auth.userId}`)
          this.dealWS(auth)
        }
      })
    }
  }

  dealWS(auth) {
    // 用于指定连接失败后的回调函数
    this.ws.onerror = (e) => {
      console.warn('连接失败重新初始化')
      setTimeout(_ => {
        this.initBench(this.auth, this.vue, false)
      }, 1000)
    }
    this.ws.onopen = () => {
      this.vue.$store.commit('changeKefuStatus', auth.kefuStatus)
      console.warn('ws 链接')
      clearInterval(this.interval)
      this.interval = setInterval(_ => {
        this.ws.send(JSON.stringify({'type': 'KEEPALIVE'}))
      }, 30000)
      this.ws.onclose = res => {
        this.ws = null
        clearInterval(this.interval)
        this.vue.$store.commit('changeKefuStatus', 'OFFLINE')
        !!this.nowVisitor && (this.nowVisitor.isHistory = true)
        console.warn('ws 已断开', res.code, res)
        if (res.code != 1000 && res.code != 1005) {
          this.initBench(this.auth, this.vue, false)
        }
      }
    }

    this.ws.onmessage = msg => {
      let msgData
      msgData = JSON.parse(msg.data)
      switch (msgData.communicateType) {
        case 'HUMAN_CVS_LIST':
          // 获取当前在线用户 visitorId:conversationId
          this.visitorIds = msgData.data.trim().split(/\t/).filter(res => res !== '').map(res => {
            let d = {}
            d.visitorId = res.split(':')[0]
            d.conversationId = res.split(':')[1]
            let v = this.visitorLIst.find(v => v.visitorId == d.visitorId)
            v && (v.conversationId = d.conversationId)
            if (this.nowVisitor && this.nowVisitor.visitorId == d.visitorId) {
              this.nowVisitor.conversationId = d.conversationId
            }
            return d
          })
          this.changeIsHistory()
          this.setSatus('UPDATA_VISITOR')

          break
        case 'VISITOR_IN':
          // todo visitorLIst和allVisitor

          let p
          this.queueCount()
          let visitorInfo = this.allVisitor.get(msgData.visitorId)
          if (!!this.nowVisitor && this.nowVisitor.visitorId == msgData.visitorId) {
            this.nowVisitor.conversationId = msgData.conversationId
          }
          if (!!visitorInfo) {
            // 如果已经存在 更新接入时间 和 isHistory
            let visitor = this.visitorLIst.find(res => res.visitorId == msgData.visitorId)
            if (!!visitor) {
              visitor.time = new Date().getTime()
              visitor.lastMessagetime = new Date().getTime()
              visitor.isHistory = false
              visitor.robotId = msgData.robotId
              visitor.conversationId = msgData.conversationId
              visitor.transfer = (msgData.data == 'transfer')
            } else {
              visitor = this.newVisitorIn(visitorInfo, msgData.conversationId)
              visitor.time = new Date().getTime()
              visitor.lastMessagetime = new Date().getTime()
              this.visitorLIst.push(visitor)
            }
            if (this.nowVisitor && (this.nowVisitor.visitorId == msgData.visitorId)) {
              this.setSatus('UPDATA_MESSAGE_LIST')
            }
            p = Promise.resolve()
          } else {
            p = this.getVisitot(msgData)
          }
          // todo 获取历史记录更新lastMessage
          p.then(_ => {
            HttpService.get(`v1/tenants/${HttpService.getCurrentUser().tenantId}/human/conversation/visitorHistory?visitorId=${msgData.visitorId}`).then(r => {
              if (!r[0]) {
                this.updataCount()
                this.notifyMe(`新客户${name}接入`, '', msgData.visitorId)
                this.setSatus('UPDATA_MESSAGE')
                this.setSatus('UPDATA_VISITOR')
                if (!this.nowVisitor || this.nowVisitor.visitorId !== msgData.visitorId) {
                  this.visitorLIst.find(res => res.visitorId === msgData.visitorId).count++
                }
              } else {
                let robotId = r[0].robotId
                HttpService.get(`/v1/tenants/${HttpService.getCurrentUser().tenantId}/robots/${robotId}/conversations/${msgData.conversationId}/human_transfer`).then(transferList => {
                  let dealMsaage = this.dealMsaage(r, transferList)
                  let messageList = dealMsaage.list
                  let humanUserId = dealMsaage.humanUserId
                  let transferListHumanUserId = transferList.filter(res => res.fromId !== '_system_robot_').map(res => res.fromId)
                  humanUserId = Array.from(new Set(humanUserId.concat(transferListHumanUserId)))
                  Promise.all([this.getRobotInfo(robotId),
                    this.getHumanUser(humanUserId)]).then(_ => {

                    this.allMessage.set(msgData.visitorId, messageList)
                    let lastMessage = messageList[messageList.length - 1]
                    this.visitorLIst.find(res => res.visitorId === msgData.visitorId).lastMessage = {
                      isRead: true,
                      msg: !!lastMessage.msg ? (lastMessage.msg.answer || lastMessage.msg.question) : '',
                      type: lastMessage.messageType
                    }
                    if (!this.nowVisitor || this.nowVisitor.visitorId !== msgData.visitorId) {
                      this.visitorLIst.find(res => res.visitorId === msgData.visitorId).count++
                    }
                    this.updataCount()
                    let name = this.allVisitor.get(msgData.visitorId).nickname
                      || this.allVisitor.get(msgData.visitorId).username
                      || this.allVisitor.get(msgData.visitorId).ip
                    this.notifyMe(`新客户${name}接入`, '', msgData.visitorId)
                    this.setSatus('UPDATA_MESSAGE')
                    this.setSatus('UPDATA_VISITOR')
                  })
                })
              }
            })
          })

          break
        case 'DATA':
          let message = new Message()
          message.time = new Date().getTime()
          if (this.vue.$route.path !== '/system/platform') {
            this.vue.$store.commit('addPlatfromCount')
          }
          switch (msgData.questionType) {
            case 'TEXT':
            case 'IMAGE':
            case 'AUDIO':
            case 'FILE':
              message.robotId = msgData.robotId
              message.visitorId = msgData.visitorId
              message.messageId = msgData.id
              message.msg = {}
              message.msg.question = msgData.data
              message.messageType = msgData.questionType
              message.conversationId = msgData.conversationId
              message.direction = 'H_IN'
              message.firstIn = true
              if (msgData.questionType == 'FILE') {
                let file = (message.msg.answer || message.msg.question || '').split('/')
                let filename = file[file.length - 1]
                message.msg.filename = filename
                message.msg.src = getFileImg(filename)
              }
              break
          }
          let dataVisitor = this.visitorLIst.find(res => res.visitorId == msgData.visitorId)
          if (!!dataVisitor) {
            dataVisitor.lastMessage = {
              isRead: this.nowVisitor && (this.nowVisitor.visitorId == msgData.visitorId),
              msg: message.msg.question,
              type: message.messageType
            }
            dataVisitor.lastMessagetime = message.time
            dataVisitor.conversationId = message.conversationId
            if (!this.nowVisitor || (this.nowVisitor.visitorId !== msgData.visitorId)) {
              dataVisitor.count++
              this.updataCount()
            }
          }

          if (this.allMessage.get(msgData.visitorId)) {
            this.allMessage.get(msgData.visitorId).push(message)
          } else {
            this.allMessage.set(msgData.visitorId, [message])
          }
          if (this.nowVisitor && (this.nowVisitor.visitorId == msgData.visitorId)) {
            this.setSatus('UPDATA_MESSAGE_LIST')
          }

          let notifyMeMsg = message.msg.question
          switch (message.messageType) {
            case 'IMAGE':
              notifyMeMsg = '[图片]'
              break
            case 'AUDIO':
              notifyMeMsg = '[语音]'
              break
          }
          if (this.allVisitor.get(msgData.visitorId)) {
            let name = this.allVisitor.get(msgData.visitorId).nickname
              || this.allVisitor.get(msgData.visitorId).username
              || this.allVisitor.get(msgData.visitorId).ip
            this.notifyMe(`客户${name}发来一条消息`, notifyMeMsg, msgData.visitorId)
          } else {
            this.getVisitot(msgData).then(visitor => {
              visitor.isHistory = false
              let name = this.allVisitor.get(msgData.visitorId).nickname
                || this.allVisitor.get(msgData.visitorId).username
                || this.allVisitor.get(msgData.visitorId).ip
              this.notifyMe(`客户${name}发来一条消息`, notifyMeMsg, msgData.visitorId)
            })
          }
          break
        case 'VISITOR_EXIT':
          this.visitorLIst.find(res => res.visitorId === msgData.visitorId).isHistory = true
          if (!!this.nowVisitor && this.nowVisitor.visitorId === msg.visitorId) {
            this.nowVisitor.isHistory = true
          }
          let v = this.visitorLIst.find(res => res.visitorId == msgData.visitorId)
          v.lastMessagetime = new Date().getTime()
          v.time = new Date().getTime()
          // console.log( this.visitorLIst.filter(res => res.isHistory).map(res => res.count).reduce((a, b) => a + b),
          // this.visitorLIst.filter(res => !res.isHistory).map(res => res.count).reduce((a, b) => a + b))
          this.updataCount()
          break
      }
      this.setSatus('UPDATA_VISITOR')
    }
  }

  getVisitot(msgData) {
    return HttpService.get(`/v1/tenants/${HttpService.getCurrentUser().tenantId}/visitors/${msgData.visitorId}`).then(v => {
      this.allVisitor.set(msgData.visitorId, v)
      let visitor = this.visitorLIst.find(res => res.visitorId == msgData.visitorId)
      if (!!visitor) {
        visitor.time = new Date().getTime()
        visitor.lastMessagetime = new Date().getTime()
        visitor.isHistory = false
      } else {
        visitor = this.newVisitorIn(v, msgData.conversationId)
        visitor.lastMessagetime = new Date().getTime()
        this.visitorLIst.push(visitor)
      }
      this.setSatus('UPDATA_VISITOR')
      return visitor
    })
  }

  updataCount() {
    let count = 0
    this.visitorLIst.filter(res => !res.isHistory).forEach(res => {
      count += res.count
    })
    this.vue.$store.commit('setPlatfromNowCount', count)
    count = 0
    this.visitorLIst.filter(res => res.isHistory).forEach(res => {
      count += res.count
    })
    this.vue.$store.commit('setPlatfromHistoryCount', count)
  }

  send(str, type = 'TEXT', url = '', communicateType = 'DATA') {
    let time = new Date().getTime()
    let visitor = this.allVisitor.get(this.nowVisitor.visitorId)
    // 发送信息
    this.ws.send(JSON.stringify({
      conversationId: this.nowVisitor.conversationId,
      visitorId: visitor.visitorId,
      kefuId: HttpService.getCurrentUser().userId,
      data: str,
      communicateType: communicateType,
      questionType: type,
      timestamp: time,
      robotId: this.nowVisitor.robotId,
      tenantId: HttpService.getCurrentUser().tenantId
    }))
    if (communicateType != 'HUMAN_FEEDBACK') {
      // 更新visitorLIst
      this.visitorLIst.find(v => v.visitorId == visitor.visitorId).lastMessage = {
        isRead: true,
        msg: str,
        type: type
      }
      this.visitorLIst.find(v => v.visitorId == visitor.visitorId).lastMessagetime = time
      // 更新messageList
      let message = {
        conversationId: this.nowVisitor.conversationId,
        direction: 'H_OUT',
        messageType: type,
        msg: {
          answer: url || str,
          answerContentType: type
        },
        robotId: this.nowVisitor.robotId,
        time: time,
        visitorId: this.nowVisitor.visitorId,
        name: visitor.username,
        humanUserId: HttpService.getCurrentUser().userId
      }
      switch (message.messageType) {
        case 'FILE':
          let file = (message.msg.answer || message.msg.question || '').split('/')
          let filename = file[file.length - 1]
          message.msg.filename = filename
          message.msg.src = getFileImg(filename)
          break
      }

      this.allMessage.get(visitor.visitorId).push(message)
    } else {
      // this.visitorLIst.find(v => v.visitorId == visitor.visitorId).lastMessage = {
      //   isRead: true,
      //   msg: '邀请评价',
      //   type: type
      // }
    }
    this.setSatus('UPDATA_MESSAGE_LIST')
  }

  sendOffLine() {
    const data = {
      communicateType: 'HUMAN_SWITCH_TO_OFFLINE',
      kefuId: HttpService.getCurrentUser().userId,
      tenantId: HttpService.getCurrentUser().tenantId,
      timestamp: new Date().getTime()
    }
    this.ws && (this.ws.send(JSON.stringify(data)))
  }

  sendOnLine() {
    const data = {
      communicateType: 'HUMAN_SWITCH_TO_ONLINE',
      kefuId: HttpService.getCurrentUser().userId,
      tenantId: HttpService.getCurrentUser().tenantId,
      timestamp: new Date().getTime()
    }

    if (this.ws && this.ws.readyState == 1) {
      this.ws.send(JSON.stringify(data))
    } else {
      setTimeout(_ => {
        this.sendOnLine()
      }, 500)
    }

  }

  sendHumanEndCvs() {
    const data = {
      communicateType: 'HUMAN_END_CVS',
      kefuId: HttpService.getCurrentUser().userId,
      tenantId: HttpService.getCurrentUser().tenantId,
      conversationId: this.nowVisitor.conversationId,
      timestamp: new Date().getTime()
    }
    this.nowVisitor.time = new Date().getTime()
    this.nowVisitor.lastMessagetime = new Date().getTime()
    this.setSatus('UPDATA_VISITOR')

    let message= {
      conversationId:this.nowVisitor.conversationId,
      createTime:new Date().getTime(),
      direction: "TRANSFER",
      fromId: HttpService.getCurrentUser().userId,
      robotId:this.nowVisitor.robotId,
      tenantId:HttpService.getCurrentUser().tenantId,
      time:new Date().getTime(),
      toId:"_system_robot_",
      updateTime:null

    }

    this.allMessage.get(this.nowVisitor.visitorId).push(message)


    this.nowVisitor = new Visitor()

    if (this.ws && this.ws.readyState == 1) {
      this.ws.send(JSON.stringify(data))
    } else {
      setTimeout(_ => {
        this.sendHumanEndCvs()
      }, 500)
    }
  }

  setSatus(status) {
    this.vue.$store.commit('changePlatformStatus', status)
    setTimeout(_ => {
      this.vue.$store.commit('changePlatformStatus', '')
    })
  }

  newVisitorIn(visitorInfo, conversationId) {
    let visitor = new Visitor()
    visitor.visitorId = visitorInfo.visitorId
    visitor.time = new Date().getTime()
    visitor.isHistory = false
    visitor.channel = visitorInfo.channel
    visitor.conversationId = conversationId
    visitor.robotId = visitorInfo.robotId
    return visitor
  }

  dealVisitorLLIst(data) {
    console.log('dealVisitorLLIst', data)
    this.visitorLIst = data.map(res => {
      let visitor = new Visitor()
      visitor.visitorId = res.visitorId
      visitor.channel = res.visitorData.channel
      visitor.robotId = res.robotId
      visitor.transfer = res.transfer
      visitor.conversationId = res.conversationId
      if (res.lastMessage) {
        visitor.messageType = res.lastMessage.messageType
        visitor.lastMessagetime = res.lastMessage.createTime
        visitor.time = res.lastMessage.createTime
        visitor.lastMessage = this.getLastMessage(res.lastMessage)
      }
      if(res.closeTime > 0) {
        visitor.lastMessagetime = res.closeTime>res.lastMessage.createTime?res.closeTime:res.lastMessage.createTime
        visitor.time = res.closeTime>res.lastMessage.createTime? res.closeTime: res.lastMessage.createTime
      }
      if (!this.allVisitor.get(visitor.visitorId)) {
        this.allVisitor.set(visitor.visitorId, res.visitorData)
      }
      return visitor
    })
    this.changeIsHistory()
    this.setSatus('UPDATA_VISITOR')
  }

  changeIsHistory() {
    this.visitorLIst && this.visitorLIst.forEach(visitor => {
      visitor.isHistory = !this.visitorIds.find(res => res.visitorId == visitor.visitorId)
      if (!visitor.isHistory) {
        visitor.conversationId = this.visitorIds.find(res => res.visitorId == visitor.visitorId).conversationId
      }
    })
  }

  // IN: 人->机器人 OUT: 人<-机器人 HIN: 人 -> 客服 HOUT: 人 <- 客服
  getLastMessage(data) {
    let messageBody = JSON.parse(data.messageBody)
    if (data.direction == 'OUT' || data.direction == 'H_OUT') {
      return {type: messageBody.answerContentType, msg: messageBody.answer, isRead: true}
    } else {
      return {type: messageBody.questionType, msg: messageBody.question, isRead: true}
    }
  }

  getRobotInfo(robotId, unionUrl, tenantId = HttpService.getCurrentUser().tenantId) {
    if (!robotId) {
      return Promise.resolve()
    }
    if (this.robots.get(robotId)) {
      return Promise.resolve(this.robots.get(robotId))
    } else {
      return HttpService.get(`/v1${unionUrl || ''}/tenants/${tenantId}/public_robot_info/${robotId}`).then(robot => {
        this.robots.set(robotId, robot)
      })
    }
  }

  getHumanUser(humanUserId, unionUrl = '', tenantId = HttpService.getCurrentUser().tenantId) {
    if (!humanUserId) {
      return Promise.resolve()
    }
    if (humanUserId instanceof Array) {
      let list = humanUserId.map(id => HttpService.get(`/v1${unionUrl}/tenants/${tenantId}/users/${id}/info`))
      return Promise.all(list).then(res => {
        res.forEach((r, i) => {
          this.allUser.set(humanUserId[i], r)
        })
      })

    } else if (this.allUser.get(humanUserId)) {
      return Promise.resolve(this.allUser.get(humanUserId))
    } else {
      return HttpService.get(`/v1/tenants/${tenantId}/users/${humanUserId}/info`).then(res => {
        this.allUser.set(humanUserId, res)
      })
    }
  }

  dealMsaage(r, transferList = []) {
    let messageList = []
    let humanUserId = []
    r.forEach((con, i) => {
      let conversationmessageList = con.messages.map(msg => {
        let data = {}
        let messageBody = JSON.parse(msg.messageBody)
        data.time = msg.createTime
        data.direction = msg.direction
        data.robotId = con.robotId || msg.robotId
        data.visitorId = con.visitorId || msg.visitorId
        data.messageType = msg.messageType
        data.messageId = msg.messageId
        data.conversationId = con.conversationId || msg.conversationId
        data.humanUserId = msg.humanUserId
        msg.humanUserId && humanUserId.push(msg.humanUserId)
        data.msg = messageBody
        data.firstIn = false
        data.name = ''
        switch (data.messageType) {
          case 'FILE':
            let file = (data.msg.answer || data.msg.question || '').split('/')
            let filename = file[file.length - 1]
            data.msg.filename = filename
            data.msg.src = getFileImg(filename)
            break
        }

        return data
      })

      transferList.forEach(transfer => {
        transfer.direction = 'TRANSFER'
        transfer.time = transfer.createTime
        conversationmessageList.push(transfer)
      })

      conversationmessageList.push({
        direction: 'TRANSFER',
        msg: '客户和机器人建立会话',
        time: conversationmessageList[0] ? (conversationmessageList[0].time - 1) : r[0].createTime,
      })
      if (r[r.length - 1].status == 'CLOSE'
        && (!transferList[transferList.length - 1]
          || transferList[transferList.length - 1].toId != '_system_robot_')) {
        conversationmessageList.push({
          direction: 'TRANSFER',
          msg: '本次会话超时，自动结束',
          time: r[r.length - 1].closeTime > 0 ? r[r.length - 1].closeTime : r[r.length - 1].updateTime
        })
      }
      conversationmessageList = conversationmessageList.sort((a, b) => {
        return a.time - b.time
      })

      messageList = messageList.concat(conversationmessageList)
    })
    humanUserId = Array.from(new Set(humanUserId))
    return {list: messageList, humanUserId: humanUserId}
  }

  // 轮训待接入会话数
  queueCount(vue) {
    console.log('待接入会话轮训')
    HttpService.get(`/v1/tenants/${HttpService.getCurrentUser().tenantId}/robot/queue/count`).then(res => {
      this.vue.$store.commit('changelineListCount', res)
    })

    if (!!nowQueueTimer) {
      clearInterval(nowQueueTimer)
    }
    nowQueueTimer = setInterval(_ => {
      if (!HttpService.getCurrentUser().tenantId) {
        clearInterval(nowQueueTimer)
      } else {
        HttpService.get(`/v1/tenants/${HttpService.getCurrentUser().tenantId}/robot/queue/count`).then(res => {
          this.vue.$store.commit('changelineListCount', res)
        })
      }
    }, 20 * 1000)
    return nowQueueTimer
  }

  clearNowQueue() {
    !!nowQueueTimer && clearInterval(nowQueueTimer)
  }

  notifyMe(title, body, visitorId) {
    // 先检查浏览器是否支持
    if (!('Notification' in window)) {
      console.error('This browser does not support desktop notification')
    } else if (Notification['permission'] === 'granted') {
      // 检查用户是否同意接受通知
      let notification = new Notification(title, {
        body: body,
        data: visitorId
      })
      notification.onclick = res => {
        window.focus()
        let visitor = this.visitorLIst.find(v => v.visitorId == res.currentTarget.data)
        visitor.count = 0
        visitor.lastMessage.isRead = true
        this.nowVisitor = visitor
        this.vue.$router.push('/system/platform')
        if (this.nowVisitor) {
          setTimeout(_ => {
            this.vue.$store.commit('changePlatformStatus', 'UPDATA_NOW_VISITOR')
            setTimeout(_ => {
              this.vue.$store.commit('changePlatformStatus', '')
            })
          })
        }
      }
    } else if (Notification['permission'] !== 'denied') {
      // 否则我们需要向用户获取权限
      Notification.requestPermission(function (permission) {
        // 如果用户同意，就可以向他们发送通知
        if (permission === 'granted') {
          let notification = new Notification(title, {
            body: body,
            data: visitorId
          })
          notification.onclick = res => {
            window.focus()
            let visitor = this.visitorLIst.find(v => v.visitorId == res.currentTarget.data)
            visitor.count = 0
            visitor.lastMessage.isRead = true
            this.nowVisitor = visitor
            this.vue.$router.push('/system/platform')
            if (this.nowVisitor) {
              setTimeout(_ => {
                this.vue.$store.commit('changePlatformStatus', 'UPDATA_NOW_VISITOR')
                setTimeout(_ => {
                  this.vue.$store.commit('changePlatformStatus', '')
                })
              })
            }
          }
        }
      })
    }
    if (this.vue.$store.state.messageTone) {
      !!audio && audio.play()
    }
    // 最后，如果执行到这里，说明用户已经拒绝对相关通知进行授权
    // 出于尊重，我们不应该再打扰他们了
  }

}




// WEBPACK FOOTER //
// ./services/platformService.js